import { render, staticRenderFns } from "./Sell-detail.vue?vue&type=template&id=0805972b&scoped=true&"
import script from "./Sell-detail.vue?vue&type=script&lang=js&"
export * from "./Sell-detail.vue?vue&type=script&lang=js&"
import style0 from "./Sell-detail.vue?vue&type=style&index=0&id=0805972b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0805972b",
  null
  
)

export default component.exports